<template>
    <div class="devices-list__block" v-if="deviceData" @click="openMotionHistory">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <device-sensor-time :time="deviceData.state.last_occupancy"></device-sensor-time>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_occupancy.slice(0, 16)}}, &nbsp
            </div>
        </v-flex>
    </div>
</template>

<script>
export default {
    name: "MotionSensorDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
    methods: {
        openMotionHistory() {
            if (this.deviceData) {
                this.$router.push({ name: "motionhistory", params: {id: this.deviceData.uid} });
            }
        },
    },
}
</script>